export const language: any = {
  add_by_image: "画像で追加",
  add_image_by_camera: "カメラで撮影",
  add_image_by_gallery: "ギャラリーから選択",
  loading: "美味しいレシピを準備中です。\n少々お待ちください。",
  retry: "再試行",
  cancel: "キャンセル",
  yes: "はい",
  no: "いいえ",
  goToIngredient: "材料を分析する",
  goToRecipe: "レシピを分析する",
  recipe: {
    title: "AIレシピ",
    analysis_results: "分析結果",
    ingredients: {
      title: "材料 (1人前)",
      view_more: "{number}個の材料をさらに表示",
      view_less: "折りたたむ",
    },
    how_to_cook: "調理方法",
    go_to_detail: "AIレシピを見る",
    description: "レシピの紹介",
    calories: "カロリー",
    time: "調理時間",
    ingredient: "主な材料",
    spice: "調味料",
    tip: "TIP",
  },
  ingredient: {
    title: "画像分析",
    analysis_results: "画像分析結果の材料は以下の通りです。",
    add_to_cart: "カートに追加",
    add_to_my_ingredients: "材料に追加",
    description: "レシピ紹介",
    time: "調理時間",
    ingredient: "主な材料",
    spice: "調味料",
    tip: "TIP",
  },
  msg: {
    not_ingredients: `素敵な写真ですが、\nここは食材専用の場所です！\n次回は美味しい食材の写真をアップしてくださいね。\n料理の秘密が待っていますよ！\nAIシェフに移動しますか？`,
    // AC-01-MSG-01
    not_recipes: `うーん、これは料理ではなさそうです！\n料理の写真だけ分析できます。\n完成した料理の写真をアップロードしてください。\n材料分析に移動しますか？`,
    not_found: "見つかりません",
    unknow: `料理や材料の写真ではないようです。\n分析のために料理や材料の写真をアップロードしていただけると、\nもっとお手伝いできると思います！`,
    upload_fail: `一時的なエラーでアップロードに失敗しました。\n少し時間をおいて再試行してください。`,
    error: `おっと！写真分析に失敗しました。\n別の写真を選ぶか、\nもっと鮮明な写真で試してみませんか？`,
    bothType: `写真には食材と料理が両方含まれています！\n写真から何を分析するか選んでください。`,
  },
}
